import React from "react";
import { formatValue } from "../../utils/Utils.js";

function DashboardCard07({ data }) {
  return (
    <div className="col-span-full xl:col-span-6 bg-white dark:bg-theme-surface-accent shadow-lg rounded-sm border border-slate-200 dark:border-slate-700">
      <header className="px-5 py-4 border-b border-slate-100 dark:border-slate-700">
        <h2 className="font-semibold text-slate-800 dark:text-slate-100">
          Top Selling Products
        </h2>
      </header>
      <div className="p-3">
        {/* Table */}
        <div className="overflow-x-auto">
          <table className="table-auto w-full dark:text-slate-300">
            {/* Table header */}
            <thead className="text-xs uppercase text-slate-400 dark:text-slate-500 bg-slate-50 dark:bg-slate-700 dark:bg-opacity-50 rounded-sm">
              <tr>
                <th className="p-2">
                  <div className="font-semibold text-left">Product</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-center">Sales</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-center">Units</div>
                </th>
              </tr>
            </thead>
            {/* Table body */}
            <tbody className="text-sm font-medium divide-y divide-slate-100 dark:divide-slate-700">
              {data.map((item, i) => (
                <tr key={i}>
                  <th className="p-2 py-3">
                    <div className="font-semibold text-left flex flex-row items-center gap-3">
                      <div className="flex items-center">
                        <img
                          className="w-8 h-8 object-cover rounded-full"
                          src={item.image}
                          alt={item.title}
                        />
                      </div>
                      {item.title}{item.subtitle ? ` ${item.subtitle}` : ""}{item.volume ? ` - ${item.volume}` : ""}
                    </div>
                  </th>
                  <th className="p-2">
                    <div className="font-semibold text-center">
                      {formatValue(item.revenue)}
                    </div>
                  </th>
                  <th className="p-2">
                    <div className="font-semibold text-center">{item.qty}</div>
                  </th>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default DashboardCard07;
